import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/reset.css'
import './index.css';
import { Provider } from 'react-redux';
import store from 'store';
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(function(registration) {
      //console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch(function(err) {
      //console.log('Service Worker registration failed:', err);
    });
}

document.addEventListener('contextmenu', (e) => e.preventDefault());
let persistor = persistStore(store);
const container = document.getElementById('root');
const root = createRoot(container); 
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>
);


serviceWorker.unregister();